export const home = {
  // Navigation
  'nav.home': 'Startseite',
  'nav.spreadsheet': 'Spreadsheet Hub',
  'nav.safety': 'Sicherheitsleitfaden',
  'nav.about': 'Über',
  'nav.contact': 'Kontakt',
  'nav.categories': 'Kategorien',
  'nav.guide': 'Kaufguide',
  'nav.search_placeholder': 'AllChinaBuy spreadsheets, Verkäufer, Produkte suchen...',

  // Hero
  'hero.title': 'Der Ultimative AllChinaBuy Spreadsheet & Kaufguide',
  'hero.subtitle': 'Finde Bessere Produkte mit dem AllChinaBuy Spreadsheet',
  'hero.description': 'Entdecken Sie nützliche AllChinaBuy spreadsheets, Verkäufer, Produktfunde, QC-Ressourcen, Versandinformationen und Kaufguides — organisiert an einem schnellen, benutzerfreundlichen Ort.',
  'hero.cta_primary': 'AllChinaBuy Spreadsheet Entdecken',
  'hero.cta_secondary': 'Kaufguides Durchsuchen',
  'hero.trust_badge': 'Unabhängige Ressource • Regelmäßig aktualisiert • Für smartere Produktsuche gebaut',
  'hero.supporting': 'Ob Sie nach einem bestimmten Produkt suchen, Verkäufer vergleichen, QC-Informationen prüfen oder Versandkosten recherchieren — unser AllChinaBuy Spreadsheet-Hub bringt die nützlichsten Ressourcen zusammen.',

  // Categories
  'categories.title': 'Beliebte AllChinaBuy Kategorien',
  'categories.description': 'Durchsuchen Sie unsere kuratierten Produktkategorien und finden Sie genau das, wonach Sie suchen.',
  'categories.all': 'Alle Kategorien',

  // Category names
  'cat.shoes': 'Schuhe',
  'cat.hoodies': 'Hoodies / Pullover',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jacken',
  'cat.pants': 'Hosen / Shorts',
  'cat.headwear': 'Kopfbedeckungen',
  'cat.sets': 'Sets',
  'cat.underwear': 'Unterwäsche / Unterhosen',
  'cat.jersey': 'Trikots',
  'cat.accessories': 'Accessoires',
  'cat.bags': 'Taschen',
  'cat.belts': 'Gürtel',
  'cat.perfumes': 'Parfums',
  'cat.other': 'Sonstiges',

  // Main website CTA buttons
  'cta.main_button': 'AllChinaBuy Spreadsheet',
  'cta.buy_now': 'Jetzt Kaufen',
  'cta.visit_main': 'Hauptseite Besuchen',
  'cta.ready_title': 'Bereit für Mehr?',
  'cta.ready_desc': 'Nutzen Sie unsere AllChinaBuy Spreadsheet-Ressourcen, um Produkte zu entdecken, Verkäufer zu vergleichen und Ihren nächsten Kauf zu recherchieren.',

  // Featured Articles
  'articles.title': 'Neueste AllChinaBuy Guides',
  'articles.description': 'Detaillierte Artikel, die Ihnen helfen, intelligentere Kaufentscheidungen zu treffen.',
  'articles.read_more': 'Vollständigen Guide Lesen',
  'articles.all_guides': 'Alle Guides Ansehen',

  // Article titles
  'article.complete_guide': 'AllChinaBuy Spreadsheet: Kompletter Guide 2026',
  'article.complete_guide_desc': 'Alles, was Sie über die Nutzung des AllChinaBuy Spreadsheet wissen müssen — von der Verkäufersuche bis zur Produktqualitätsprüfung.',
  'article.is_legit': 'Ist AllChinaBuy Legit? Kompletter Sicherheitsleitfaden',
  'article.is_legit_desc': 'Wir analysieren Sicherheit, Vertrauenssignale und Risiken beim Kauf über AllChinaBuy. Lernen Sie, wie Sie sich schützen.',
  'article.shipping': 'AllChinaBuy Versandkosten Guide 2026',
  'article.shipping_desc': 'Detaillierte Aufschlüsselung der Versandmethoden, Kosten nach Land und Tipps zum Sparen bei Liefergebühren.',
  'article.coupon': 'AllChinaBuy Gutschein & Rabattcode Guide',
  'article.coupon_desc': 'So finden und nutzen Sie AllChinaBuy-Gutscheine, Rabattcodes und Saisonaktionen für maximale Ersparnisse.',
  'article.review': 'AllChinaBuy Review: Funktionen & Kauferlebnis',
  'article.review_desc': 'Eine ehrliche, unabhängige Bewertung der AllChinaBuy-Plattform mit Suche, Bestellung, QC und Versand.',
  'article.qc': 'AllChinaBuy QC Foto Guide: Worauf Sie Achten Sollten',
  'article.qc_desc': 'Lernen Sie, QC-Fotos zu lesen, Mängel zu erkennen und Artikel vor dem Versand zu genehmigen oder abzulehnen.',
  'article.how_to_use': 'So Nutzen Sie das AllChinaBuy Spreadsheet',
  'article.how_to_use_desc': 'Eine Schritt-für-Schritt-Anleitung der Spreadsheet-Oberfläche, vom Durchsuchen der Kategorien bis zur ersten Bestellung.',
  'article.seller_guide': 'AllChinaBuy Verkäufer-Guide: Vertrauenswürdige Verkäufer Finden',
  'article.seller_guide_desc': 'So bewerten Sie Verkäufer-Ruf, Bewertungen und Kommunikation vor dem Kauf.',
  'article.beginner_guide': 'AllChinaBuy Anfänger-Guide: Sicher Starten',
  'article.beginner_guide_desc': 'Eine vollständige Einführung für Erstkäufer mit Konten, Bestellungen, QC und Versand.',
  'article.best_finds': 'Beste AllChinaBuy Funde: Produkte, die sich Lohnen',
  'article.best_finds_desc': 'Unsere kuratierten Auswahlen trendiger Schuhe, Kleidung, Taschen und Accessoires.',
  'article.warehouse': 'AllChinaBuy Warehouse Guide: Lagerung, QC & Versand',
  'article.warehouse_desc': 'Verstehen Sie, wie das Warehouse Ihre Bestellungen vor dem Versand lagert, prüft und konsolidiert.',
  'article.alternatives': 'AllChinaBuy Alternativen: Plattformen im Vergleich',
  'article.alternatives_desc': 'Ein ausgewogener Vergleich von AllChinaBuy und anderen Shopping-Agent-Plattformen.',
  'article.payment': 'AllChinaBuy Zahlungs- & Rückerstattungsguide',
  'article.payment_desc': 'Zahlungsmethoden, Rückerstattungsrichtlinien und die Lösung von Bestellproblemen.',
  'article.tracking': 'AllChinaBuy Tracking Guide: Bestellung Verfolgen',
  'article.tracking_desc': 'So verfolgen Sie Ihr Paket vom Warehouse bis zur Haustür mit nützlichen Tipps.',
  'article.qc_checklist': 'AllChinaBuy QC Checkliste: Vor dem Versand Prüfen',
  'article.qc_checklist_desc': 'Eine ausdruckbare Checkliste, was in QC-Fotos vor der Versandfreigabe zu prüfen ist.',
  'article.best_sellers': 'Beste AllChinaBuy Verkäufer 2026: Vertrauenswürdige Shops',
  'article.best_sellers_desc': 'Die Verkäufer mit dem stärksten Ruf in beliebten Produktkategorien.',

  // Trust section
  'trust.title': 'Ist AllChinaBuy Sicher zu Nutzen?',
  'trust.subtitle': 'Unsere unabhängige Sicherheitsbewertung',
  'trust.desc': 'Wir haben die AllChinaBuy-Plattform unabhängig analysiert. Diese Website ist nicht mit AllChinaBuy verbunden. Wir bieten ehrliche, forschungsbasierte Informationen, um Ihnen bei fundierten Entscheidungen zu helfen.',
  'trust.checklist_title': 'Sicherheitscheckliste Vor dem Kauf',
  'trust.check_1': 'Verkäufers Ruf und Bewertungen prüfen',
  'trust.check_2': 'QC-Fotos vor Versandfreigabe prüfen',
  'trust.check_3': 'Sichere Zahlungsmethoden verwenden',
  'trust.check_4': 'Versandkosten und Methoden vergleichen',
  'trust.check_5': 'Neueste Käufererfahrungen lesen',
  'trust.read_more': 'Vollständigen Sicherheitsleitfaden Lesen',

  // FAQ
  'faq.title': 'Häufig Gestellte Fragen',
  'faq.q1': 'Was ist das AllChinaBuy Spreadsheet?',
  'faq.a1': 'Das AllChinaBuy Spreadsheet ist eine kuratierte Sammlung von Produktlinks, Verkäuferinformationen und Kaufressourcen, die Käufern hilft, Qualitätsprodukte über die AllChinaBuy-Plattform zu finden. Es organisiert Produkte nach Kategorie mit Links, Preisen und Verkäuferbewertungen.',
  'faq.q2': 'Wie verwende ich das AllChinaBuy Spreadsheet?',
  'faq.a2': 'Durchsuchen Sie einfach die Kategorien, die Sie interessieren, klicken Sie auf Produktlinks, um Details auf der AllChinaBuy-Plattform anzusehen, und folgen Sie den Kaufguides für ein reibungsloses Kauferlebnis. Wir empfehlen, mit unserem Kompletten Guide für Anfänger zu beginnen.',
  'faq.q3': 'Ist AllChinaBuy legitim?',
  'faq.a3': 'AllChinaBuy ist eine bekannte Shopping-Agent-Plattform. Wie jeder Online-Marktplatz variieren die Käufererfahrungen. Wir empfehlen, unseren unabhängigen Sicherheitsguide zu lesen, Verkäuferbewertungen zu prüfen und immer QC-Fotos vor Versandfreigabe zu nutzen.',
  'faq.q4': 'Wie viel kostet AllChinaBuy-Versand?',
  'faq.a4': 'Versandkosten variieren je nach Ziel, Gewicht und Versandmethode. Unser Versandkosten-Guide bietet detaillierte Schätzungen für USA, UK, Deutschland, Frankreich, Dänemark und andere Länder.',
  'faq.q5': 'Hat AllChinaBuy Gutscheine?',
  'faq.a5': 'AllChinaBuy bietet gelegentlich Gutscheine und Rabattcodes an. Sehen Sie sich unseren Gutschein-Guide für die neuesten Angebote und Tipps zur Maximierung Ihrer Ersparnisse an.',

  // Footer
  'footer.about_title': 'Über Diese Website',
  'footer.about_desc': 'AllChinaBuySpread ist ein unabhängiges Ressourcen-Hub. Wir sind nicht offiziell mit AllChinaBuy verbunden. Alle Informationen dienen ausschließlich Forschungs- und Bildungszwecken.',
  'footer.links_title': 'Schnelllinks',
  'footer.link_safety': 'Sicherheitsleitfaden',
  'footer.link_about': 'Über Uns',
  'footer.link_contact': 'Kontakt',
  'footer.link_disclaimer': 'Haftungsausschluss',
  'footer.legal': 'Dies ist eine unabhängige Ressourcen-Website. Produktlinks leiten zu AllChinaBuy und kaspreadsheet.com weiter.',
  'footer.copyright': '© 2026 AllChinaBuySpread. Alle Rechte vorbehalten.',

  // Common
  'common.loading': 'Wird geladen...',
  'common.read_time': 'Min. Lesezeit',
  'common.updated': 'Aktualisiert',
  'common.independent': 'Unabhängige Ressource',
};